import { configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "../reducer/authentication";

export default configureStore({
  reducer: {
    authenticationReducer,
  },
});
